export default __webpack_public_path__ + "static/media/HC5.d2803288.jpg";